import { isArrayOfType, isPropertyKey, isString, isSymbol, isNumber, exhaustiveGuard } from "@mcwd/typescript-type-guards";

export function parsePropPath (path: PropertyKey | PropertyKey[])
{
  if (isArrayOfType(path, isPropertyKey))
  {
    return path;
  }
  if (isString(path))
  {
    return path.split(".");
  }
  if (isSymbol(path))
  {
    return [ path ];
  }
  if (isNumber(path))
  {
    return [ path ];
  }
  exhaustiveGuard(path);
}
